import React from 'react';

import { Button } from '@copilot/ui';

// Extracted from AdminUsersPage.jsx (Task 8) so meetings/audit lists
// reuse the exact same server-side pagination controls instead of each
// re-implementing them - renders nothing once everything fits on one
// page, same as the original inline version.
function AdminPagination({ page, totalPages, total, itemLabel, onPageChange, ariaLabel }) {
  if (totalPages <= 1) return null;

  return (
    <nav className="admin-pagination" aria-label={ariaLabel}>
      <span className="admin-pagination-summary">
        Page {page} of {totalPages} ({total} {itemLabel})
      </span>

      <div className="admin-pagination-controls">
        <Button
          variant="secondary"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          aria-label="Previous page"
        >
          Previous
        </Button>
        <Button
          variant="secondary"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages}
          aria-label="Next page"
        >
          Next
        </Button>
      </div>
    </nav>
  );
}

export default AdminPagination;
